<div id="labelCOMP-div">
  <label id="labelCOMP-div-label" class="label-font">{{ field.displayName }}</label>
</div>
<div id="labelCOMP-div2">
  <strong id="labelCOMP-div-strong">{{ getControlLabel() }}</strong>
</div>
